import React from 'react';

export default class UserRow extends React.Component {
  render() {
    const {RowData} = this.props;
    return (
      <tr>
        <td>
          <div>
            <strong>{RowData.FirstName + ' ' + RowData.LastName}</strong>{' ('+ RowData.Username +')'}
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/tenant/tenant/helper/component/UserList/UserRow.js